export default {
	methods: 
    {		
	},
}